export default "/biometrie-afghanistan/fonts/open-sans-v17-latin-italic.woff";